function withEditorContext(
  path: string,
  clinicianCode: string,
  returnUrl: string,
) {
  const url = new URL(path, window.location.origin);
  void clinicianCode;
  const returnDestination = new URL(returnUrl, window.location.origin);
  returnDestination.searchParams.delete("clinicianCode");
  url.searchParams.set("returnUrl", returnDestination.toString());
  return url.toString();
}

export function homeworkStepsEditorPath({
  clinicianCode,
  patientId,
  homeworkAssignmentId,
  returnUrl,
}: {
  clinicianCode: string;
  patientId: string;
  homeworkAssignmentId: string;
  returnUrl: string;
}) {
  const path = withEditorContext(
    `/clinician-portal/homework-activities/${encodeURIComponent(patientId)}/${encodeURIComponent(homeworkAssignmentId)}/steps`,
    clinicianCode,
    returnUrl,
  );
  const url = new URL(path, window.location.origin);
  url.searchParams.set("edit", "1");
  return url.toString();
}

export function templateStepsEditorPath({
  clinicianCode,
  templateId,
  returnUrl,
}: {
  clinicianCode: string;
  templateId: string;
  returnUrl: string;
}) {
  return withEditorContext(
    `/clinician-portal/activity-templates/${encodeURIComponent(templateId)}/steps`,
    clinicianCode,
    returnUrl,
  );
}
